import { useEffect, useMemo } from 'react';
import { useConversationStore } from '../../stores/conversationStore';
import { ChatItem } from './ChatItem';

export function ChatList() {
  const { conversations, activeConversationId, loadConversations, isLoading } =
    useConversationStore();

  useEffect(() => {
    loadConversations();
  }, [loadConversations]);

  // Filter out archived conversations for the sidebar
  const activeConversations = useMemo(
    () => conversations.filter((conv) => !conv.isArchived),
    [conversations]
  );

  if (isLoading && conversations.length === 0) {
    return (
      <div className="p-4 text-center text-muted-foreground text-sm">
        Chats werden geladen...
      </div>
    );
  }

  if (activeConversations.length === 0) {
    return (
      <div className="p-4 text-center text-muted-foreground text-sm">
        Noch keine Chats vorhanden.
        <br />
        Klicken Sie auf "Neuer Chat", um zu beginnen.
      </div>
    );
  }

  return (
    <div className="p-3 space-y-1">
      {activeConversations.map((conversation) => (
        <ChatItem
          key={conversation.id}
          conversation={conversation}
          isActive={conversation.id === activeConversationId}
        />
      ))}
    </div>
  );
}
